import { useEffect, useState } from 'react';
import { Workflow } from 'modules/workflows/types';
import { startEditorText } from './EntranceLimitForm.constants';
import { validateEntranceLimit, validateSimultaneousLimit } from './EntranceLimitForm.utils';
import { SimultaneousLimitInput } from './SimultaneousLimitInput';
import { LifetimeLimitInput } from './LifetimeLimitInput';
import { useStartNodeContext } from '../StartNodeEditor.context';
import { ConcurrentJourneyEntranceCriteria } from './ConcurrentJourneyEntranceCriteria';
import { useSelector } from 'react-redux';
import { getIsJourneyStartTileConcurrentJourneyEntranceCriteriaEnabled } from 'modules/workflows/ducks';

export const EntranceLimitForm = () => {
  const { isReadOnly, setWorkflowData, workflowData } = useStartNodeContext();
  const isJourneyStartTileConcurrentJourneyEntranceCriteriaEnabled = useSelector(
    getIsJourneyStartTileConcurrentJourneyEntranceCriteriaEnabled,
  );
  const [errors, setErrors] = useState<Record<string, string>>({});

  useEffect(() => {
    const { workflowLifetimeLimit: ll, workflowSimultaneousLimit: sl } = workflowData;
    const llError = validateEntranceLimit(ll) || '';
    const slError = validateSimultaneousLimit(sl, ll, startEditorText) || '';
    if (errors.lifetimeLimit !== llError || errors.simultaneousLimit !== slError) {
      setErrors({ lifetimeLimit: llError, simultaneousLimit: slError });
    }
  }, [workflowData.workflowLifetimeLimit, workflowData.workflowSimultaneousLimit]);

  const updateInternalWorkflowData = (updates: Partial<Workflow>) =>
    setWorkflowData({ ...workflowData, ...updates });

  const selectedJourneys = workflowData?.workflowConcurrentJourneyEntranceCriteria
    ? workflowData.workflowConcurrentJourneyEntranceCriteria.journeys
    : undefined;

  return (
    <>
      <LifetimeLimitInput
        onLifetimeLimitUpdate={(limit) => {
          updateInternalWorkflowData({ workflowLifetimeLimit: limit });
        }}
        lifetimeLimit={workflowData.workflowLifetimeLimit || null}
        error={errors.lifetimeLimit}
        isReadOnly={isReadOnly}
      />
      <SimultaneousLimitInput
        onSimultaneousLimitUpdate={(limit) => {
          updateInternalWorkflowData({ workflowSimultaneousLimit: limit });
        }}
        simultaneousLimit={workflowData.workflowSimultaneousLimit || null}
        error={errors.simultaneousLimit}
        isReadOnly={isReadOnly}
      />
      {isJourneyStartTileConcurrentJourneyEntranceCriteriaEnabled && (
        <ConcurrentJourneyEntranceCriteria
          onConcurrentJourneyEntranceCriteriaUpdate={(journeys) => {
            updateInternalWorkflowData({
              workflowConcurrentJourneyEntranceCriteria:
                journeys === undefined
                  ? undefined
                  : {
                      journeys,
                    },
            });
          }}
          journeys={selectedJourneys}
          isReadOnly={isReadOnly}
        />
      )}
    </>
  );
};
